import React, { useState, useRef, useEffect } from 'react';
import { FiSmile, FiSend } from 'react-icons/fi';
import EmojiPicker from 'emoji-picker-react';
import Button from '../../../shared/components/Button/Button';
import styles from './MessageInput.module.css';

export default function MessageInput({ value, onChange, onSend }) {
  const [showEmoji, setShowEmoji] = useState(false);
  const emojiRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (
        emojiRef.current && !emojiRef.current.contains(e.target) &&
        btnRef.current && !btnRef.current.contains(e.target)
      ) {
        setShowEmoji(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const handleEmoji = (data) => {
    onChange({ target: { value: value + data.emoji } });
  };

  return (
    <div className={styles.bar}>
      <input
        className={styles.input}
        value={value}
        onChange={onChange}
        placeholder="Type a message..."
        onKeyDown={handleKey}
      />

      {showEmoji && (
        <div className={styles.picker} ref={emojiRef}>
          <EmojiPicker onEmojiClick={handleEmoji} />
        </div>
      )}

      <button
        className={styles.emojiBtn}
        onClick={() => setShowEmoji((p) => !p)}
        ref={btnRef}
        aria-label="Toggle emoji picker"
      >
        <FiSmile size={18} />
      </button>

      <Button
        variant="primary"
        size="small"
        icon={<FiSend size={15} />}
        onClick={onSend}
        className={styles.sendBtn}
      >
        Send
      </Button>
    </div>
  );
}
